import { FETCH_PATIENT_HISTORY_REPORTS_SUCCESS, RESET_REPORT_EDITOR, SET_REPORT_EDITOR_UNSAVED_CHANGES, UNLOCK_REPORT_EDITOR_VISIT_ERROR, UNLOCK_REPORT_EDITOR_VISIT_START, UPDATE_DICTATION_REPORT_ERROR, UPDATE_DICTATION_REPORT_START, UPDATE_DICTATION_REPORT_SUCCESS } from '../../actions/typist/reportEditorAction';
import { VIEW_PARKED_VISIT_ERROR, VIEW_PARKED_VISIT_START, VIEW_PARKED_VISIT_SUCCESS } from '../../actions/typist/typistParkedAction';
import { VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS } from '../../actions/typist/typistSubmittedAction';
import { VIEW_SUBMITTED_FOR_TYPING_VISIT_START, VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, FETCH_RADIOLOGIST_TEMPLATES_SUCCESS } from '../../actions/typist/typistWorklistAction';

const INIT_STATE = {
    error: "",
    message: '',
    loading: false,
    submitting: false,
    unlocking: false,
    isReportTextModified: false,
    reportEditor: null,
    radiologistTemplates: [],
    found: false,
    priorReportsLoaded: false,
    patientHistoryReports: [],
};

const reportEditorReducer = (state = INIT_STATE, action) => {
    let newReportEditor;
    let newVisit;
    let newDictations;
    let index;
    switch (action.type) {
        case RESET_REPORT_EDITOR: {
            return { ...INIT_STATE };
        }
        case VIEW_SUBMITTED_FOR_TYPING_VISIT_START:
        case VIEW_PARKED_VISIT_START:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START: {
            return { ...state, error: '', message: '', found: false, loading: true, priorReportsLoaded: false, patientHistoryReports: [] };
        }
        case VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS:
        case VIEW_PARKED_VISIT_SUCCESS:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            return { ...state, error: '', message: '', found: true, loading: false, reportEditor: { ...action.report }, priorReportsLoaded: false, patientHistoryReports: [] };
        }
        case FETCH_PATIENT_HISTORY_REPORTS_SUCCESS: {
            return { ...state, error: '', message: '', patientHistoryReports: action.patientHistoryReports, priorReportsLoaded: true };
        }
        case VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR:
        case VIEW_PARKED_VISIT_ERROR:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case SET_REPORT_EDITOR_UNSAVED_CHANGES: {
            return { ...state, isReportTextModified: action.unsavedChanges };
        }
        case UNLOCK_REPORT_EDITOR_VISIT_START: {
            return { ...state, unlocking: true };
        }
        case UNLOCK_REPORT_EDITOR_VISIT_ERROR: {
            return { ...state, unlocking: false };
        }
        case FETCH_RADIOLOGIST_TEMPLATES_SUCCESS: {
            return { ...state, radiologistTemplates: action.radiologistTemplates };
        }
        case UPDATE_DICTATION_REPORT_START: {
            return { ...state, submitting: true };
        }
        case UPDATE_DICTATION_REPORT_SUCCESS: {
            newReportEditor = { ...state.reportEditor };
            newVisit = { ...newReportEditor.visit, ...action.visit };
            newReportEditor.visit = { ...newVisit };
            return { ...state, submitting: false, isReportTextModified: false, reportEditor: { ...newReportEditor } };
        }
        case UPDATE_DICTATION_REPORT_ERROR: {
            return { ...state, submitting: false };
        }
        default:
            return state;
    }
}

export default reportEditorReducer;
